import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

const CollapsibleRoot = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

const Collapsible = Object.assign(CollapsibleRoot, {
    Content: CollapsibleContent,
    Trigger: CollapsibleTrigger,
});

export { Collapsible, CollapsibleContent, CollapsibleRoot, CollapsibleTrigger };
